import { render, staticRenderFns } from "./Gate.vue?vue&type=template&id=63ed6569&scoped=true"
import script from "./Gate.vue?vue&type=script&lang=ts"
export * from "./Gate.vue?vue&type=script&lang=ts"
import style0 from "./Gate.vue?vue&type=style&index=0&id=63ed6569&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ed6569",
  null
  
)

export default component.exports